import { createContext } from 'react';

import { Viewport } from '../../util/responsive/types';

import { type UseViewportStateParams } from './internal-hooks/use-viewport-state';
import { type ViewportContext, type ViewportFlags } from './types';

export const ViewportContextObj = createContext<undefined | ViewportContext>(undefined);

export interface DeriveViewportContextParams extends Required<
  Omit<UseViewportStateParams, 'initialSize'>
> {
  readonly size: number;
}

export const deriveViewportContext = ({ size, viewport }: DeriveViewportContextParams) => ({
  size,
  viewport,
  ...Object.values(Viewport).reduce((acc, vp) => {
    if (viewport === vp) {
      return { ...acc, [`is${vp}`]: true };
    }
    return { ...acc, [`is${vp}`]: false };
  }, {} as ViewportFlags),
});
